export const DEFAULT_TYPE = 'big';
